// removed by extract-text-webpack-plugin
module.exports = {"Message":"Tbivx-jvypoO6ME5tXX0s"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Message/Message.scss
 ** module id = 395
 ** module chunks = 1
 **/